import { useUpcomingAppointmentsCountQuery } from '@lingoda/monolith-graphql';

export const useUpcomingAppointmentsCount = () => {
    const { data, loading } = useUpcomingAppointmentsCountQuery();

    return {
        count: data?.upcomingAppointmentsCount,
        hasUpcomingAppointments: !!data?.upcomingAppointmentsCount,
        loading,
    };
};
